/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import Avatarly from '../../avatarly';

const RenAvatarly = ({
  data, accessor, onAction,
}) => {
  const dataForAccessor = data[accessor];
  const { icon: CustomIcon, actionIcons } = dataForAccessor || {};

  const renderIcon = CustomIcon
    ? ({ size, color }) => <CustomIcon size={size} color={color} />
    : null;

  return (
    <Avatarly
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...dataForAccessor}
      onAction={onAction}
      actionIcons={actionIcons}
      renderIcon={renderIcon}
    />
  );
};
RenAvatarly.defaultProps = {
  data: {},
  onAction: () => { },
  renderActionIcon: null,
};

RenAvatarly.propTypes = {
  accessor: PropTypes.string.isRequired,
  data: PropTypes.shape(),
  onAction: PropTypes.func,
  renderActionIcon: PropTypes.func,
};

export default RenAvatarly;
